export default __webpack_public_path__ + "static/media/Restart.b6fd2004.svg";